import { render, staticRenderFns } from "./CallRecordPlayer.vue?vue&type=template&id=47b1a16c"
import script from "./CallRecordPlayer.vue?vue&type=script&lang=js"
export * from "./CallRecordPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports